import { useTranslation } from '@thoughtspot/i18n';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import React from 'react';
import { Vertical } from "../../../utils/layouts";
import { getIsNewLlmConfig } from '../llm-form/llm-form-utils';
import { getIsLLMGatewayEnabled } from '../llm-gateway/llm-gateway.util';
import styles from './setting.module.scss';
import { renameLLMProvider } from './setting-content.util';
const LLM_CONFIG_ID = 'orion.aiModelType';
export const SettingContent = ({ configs, isCustomerLLMAccount = false, provider = '', }) => {
    const { t } = useTranslation();
    const isLLMConfig = !!(configs.find((config) => config.id === LLM_CONFIG_ID) !== undefined);
    const isNewLlmConfig = getIsNewLlmConfig();
    const isLLMGatewayV2Enabled = getIsLLMGatewayEnabled();
    return (React.createElement(React.Fragment, null, configs && (React.createElement(Vertical, { className: styles.settingContentContainer }, isLLMConfig &&
        (isNewLlmConfig || isLLMGatewayV2Enabled) ? (React.createElement("div", { className: styles.llmContainer },
        React.createElement("div", { className: styles.llmItem },
            React.createElement("div", null, t('admin.settingsContent.provider')),
            React.createElement("div", { className: styles.llmValue }, renameLLMProvider(provider))))) : (React.createElement(FormBuilder, { formFields: configs, viewMode: "view" }))))));
};
//# sourceMappingURL=setting-content.js.map